export default __webpack_public_path__ + "static/media/try.5ca13a47.png";